<template>
  <div>
    <h1>ECOMMMPAGE</h1>
  </div>
</template>

<script>
export default {
  name: 'Ecomm-test',
  created () {
    console.log('Hi from ecommtest')
  }
}
</script>

<style>

</style>